import { Controller } from "@hotwired/stimulus";

// A <details> holds its open state in a DOM attribute the server never renders, so a
// morph closes it.
export default class extends Controller {
  connect() {
    if (this.wasOpen === undefined) this.wasOpen = this.element.open;
  }

  remember() {
    this.wasOpen = this.element.open;
  }

  restore() {
    this.element.open = this.wasOpen;
  }

  // Saving ends the editing, so the card closes on the way back.
  forget() {
    this.wasOpen = false;
  }

  // The drag handle sits inside <summary>, where a click would otherwise toggle.
  ignoreClick(event) {
    event.preventDefault();
  }
}
